const hi = {
  // NAV
  nav_features: "फीचर्स",
  nav_how: "कैसे काम करता है",
  nav_pricing: "प्राइसिंग",
  nav_portals: "पोर्टल्स",
  nav_signin: "साइन इन",
  nav_signup: "शुरू करें",
  nav_dashboard: "डैशबोर्ड खोलें",

  // HERO
  hero_badge: "12,000+ परिवारों का भरोसा",
  hero_line1: "दुनिया का सबसे",
  hero_line2: "स्मार्ट",
  hero_line3: "सुरक्षा नेटवर्क।",
  hero_sub:
    "Guardian360 एक QR कोड को जीवनरेखा में बदल देता है — तुरंत आपातकालीन संपर्क, लाइव GPS, AI सहायता, और सामुदायिक सुरक्षा। आपके लिए, आपके बच्चों, कार, पालतू जानवर — सबके लिए।",
  cta_protect: "अभी सुरक्षित हों",
  cta_how: "कैसे काम करता है देखें",
  ok_no_cc: "कोई क्रेडिट कार्ड नहीं",
  ok_gdpr: "GDPR अनुरूप",
  ok_offline: "ऑफ़लाइन काम करता है (QR से)",
  hero_alert_title: "माया स्कूल सुरक्षित पहुँची",
  hero_alert_meta: "2 मिनट पहले · ज़ोन: सुरक्षित",
  hero_alert_label: "लाइव अलर्ट",
  hero_scan_title: "वाहन KA-01-AB-4231",
  hero_scan_meta: "किसी ने आपसे संपर्क किया",
  hero_scan_label: "QR स्कैन हुआ",
  hero_scroll: "स्क्रॉल करें",

  // LIVE TICKER
  ticker_live: "लाइव",
  ticker_sos: "SOS इस हफ्ते हल हुए",
  ticker_scans: "QR स्कैन प्रोसेस हुए",
  ticker_reunited: "परिवार Lost & Found से मिले",
  ticker_cities: "शहरों में उपलब्ध",
  ticker_uptime: "अपटाइम",

  // CORE CAPABILITIES
  cap_kicker: "मुख्य क्षमताएँ",
  cap_title: "चार क्षमताएँ। एक QR।",
  cap_sub: "हर Guardian स्टिकर पूरी सुरक्षा प्रणाली खोलता है। कोई हार्डवेयर नहीं, बैटरी नहीं — ऑफ़लाइन भी काम करता है।",
  cap_1_tag: "SOS अलर्ट",
  cap_1_title: "एक-टैप आपातकालीन ब्रॉडकास्ट",
  cap_1_desc: "लाइव लोकेशन, फ़ोटो + वीडियो परिवार, वॉलंटियर, पुलिस और एम्बुलेंस को रीयल टाइम में।",
  cap_2_tag: "लोकेशन खोजें",
  cap_2_title: "लाइव फैमिली रडार",
  cap_2_desc: "अपनों को लाइव मैप पर देखें — बैटरी, स्पीड और सेफ-ज़ोन अलर्ट के साथ।",
  cap_3_tag: "रूट ट्रैकिंग",
  cap_3_title: "यात्रा + रैश-ड्राइविंग अलर्ट",
  cap_3_desc: "ओवर-स्पीड, रैश-ड्राइविंग और ब्लैक-स्पॉट चेतावनी — दुर्घटना से पहले।",
  cap_4_tag: "क्रैश डिटेक्शन",
  cap_4_title: "स्वचालित आपातकालीन प्रतिक्रिया",
  cap_4_desc: "टक्कर का पता लगाकर पास के प्रतिक्रियादाता को भेजता है + परिवार को SMS।",
  cap_explore: "एक्सप्लोर",

  // STATS
  stat_families: "परिवार सुरक्षित",
  stat_scans: "QR स्कैन",
  stat_sos: "SOS / सप्ताह",
  stat_sla: "रिस्पॉन्डर SLA",

  // CATEGORIES
  cat_kicker: "हम किनकी रक्षा करते हैं",
  cat_title: "हर स्थिति के लिए एक Guardian।",
  cat_sub: "बच्चे के बैग से लेकर कॉर्पोरेट फ्लीट तक — एक प्लेटफ़ॉर्म, हर ज़रूरत।",
  cat_get_qr: "QR लें",
  cat_vehicle: "वाहन सुरक्षा",
  cat_child: "बाल सुरक्षा",
  cat_family: "पारिवारिक सुरक्षा",
  cat_senior: "बुज़ुर्ग देखभाल",
  cat_pet: "पालतू सुरक्षा",
  cat_lostfound: "खोया-पाया",
  cat_corporate: "कॉर्पोरेट व फ्लीट",
  cat_emergency: "आपातकालीन सेवाएँ",

  // HOW IT WORKS
  steps_kicker: "कैसे काम करता है",
  steps_title: "तीन कदम। जीवन भर की मन की शांति।",
  steps_sub: "एक बार सेट करें। Guardian360 चुपचाप आपकी और आपके अपनों की रक्षा करता है — जब तक ज़रूरत न पड़े।",
  steps_cta: "अभी सुरक्षा शुरू करें",
  step_1_t: "अपना Guardian बनाएँ",
  step_1_d: "30 सेकंड में साइनअप करें। आपातकालीन संपर्क, चिकित्सा जानकारी और फ़ोटो जोड़ें।",
  step_2_t: "अपना QR प्रिंट करें",
  step_2_d: "पर्स, चाबी, कार, पालतू कॉलर, सामान के लिए हाई-रेज़ QR स्टिकर डाउनलोड करें।",
  step_3_t: "सुरक्षित रहें",
  step_3_d: "जो भी स्कैन करेगा आप तक पहुँच जाएगा। एक टैप में SOS ट्रिगर करें।",

  // MODULES
  fs_kicker: "Guardian स्टैक",
  fs_title: "सुरक्षित महसूस करने के लिए ज़रूरी सब कुछ — एक ही जगह।",
  fs_sub: "14 मॉड्यूल। एक अकाउंट। असली आपात स्थितियों के लिए बना।",
  mod_1_t: "स्मार्ट डिजिटल ID",
  mod_1_d: "एक स्कैन में आपातकालीन संपर्क, चिकित्सा जानकारी और GPS सिग्नल — स्कैन करने वाले को ऐप भी नहीं चाहिए।",
  mod_2_t: "एक-टैप आपातकालीन SOS",
  mod_2_d: "आपकी लाइव लोकेशन तुरंत वॉलंटियर, परिवार और पास के प्रतिक्रियादाताओं को भेजता है।",
  mod_3_t: "फैमिली रडार",
  mod_3_d: "अपनों को लाइव मैप पर देखें। सेफ़-ज़ोन छोड़ने पर तुरंत अलर्ट।",
  mod_4_t: "वाहन QR",
  mod_4_d: "गलत पार्किंग? कोई भी आपके कार के स्टिकर को स्कैन करके आप तक निजी तरीके से पहुँच सकता है।",
  mod_5_t: "खोया-पाया",
  mod_5_d: "सामान, चाबी, पालतू पर QR टैग लगाएँ — स्कैन होते ही तुरंत सूचना।",
  mod_6_t: "Guardian AI",
  mod_6_d: "24/7 प्रमाणित आपातकालीन मार्गदर्शन। चिकित्सा, आग, सड़क — आप कभी अकेले नहीं।",
  mod_7_t: "समुदाय निगरानी",
  mod_7_d: "अनाम घटना फ़ीड + हीटमैप। जानें आपके इलाके में क्या हो रहा है।",
  mod_8_t: "गोपनीयता पहले",
  mod_8_d: "आप तय करें कि स्कैनर क्या देखे। हर स्कैन का पूरा ऑडिट लॉग।",

  // APP DOWNLOAD
  app_kicker: "मोबाइल ऐप",
  app_title: "वह ऐप जो आपके सोते हुए भी जागता है।",
  app_sub: "SOS बटन, लाइव फैमिली मैप और Guardian AI आपकी जेब में। iOS + Android। वेब का ही अकाउंट।",
  app_get_google: "पर उपलब्ध",
  app_google: "Google Play",
  app_get_apple: "पर डाउनलोड करें",
  app_apple: "App Store",
  app_coming: "जल्द आ रहा है",
  app_rating: "ऐप रेटिंग",
  app_downloads: "डाउनलोड्स",
  app_console: "Guardian कंसोल",
  app_greet: "नमस्ते, आरव।",
  app_live_sos: "लाइव SOS",
  app_responders: "2 रिस्पॉन्डर आ रहे हैं",

  // PORTALS
  portals_kicker: "इकोसिस्टम",
  portals_title: "हर प्रतिक्रियादाता के लिए विशेष पोर्टल।",
  portal_role: "पोर्टल",

  // TESTIMONIALS
  testi_kicker: "असली कहानियाँ",
  testi_title: "जिनकी हमने मदद की — उन्हीं के शब्दों में।",
  testi_1_name: "इमरान अली", testi_1_city: "लखनऊ",
  testi_1_quote: "जाम में बेहोश होने पर एक अजनबी ने मेरी कार का Guardian QR स्कैन किया। 15 सेकंड में मेरी पत्नी को कॉल और लाइव मैप मिल गया। सच में जान बचा ली।",
  testi_2_name: "स्वाति सिंह", testi_2_city: "पटना",
  testi_2_quote: "मेरा कुत्ता ब्रूनो पार्क में गुम हो गया। किसी ने उसका कॉलर टैग स्कैन किया — चाय ख़त्म होने से पहले फ़ोन बज गया। 12 मिनट में मिल गया।",
  testi_3_name: "रजत पटेल", testi_3_city: "अहमदाबाद",
  testi_3_quote: "रात 2 बजे AI असिस्टेंट ने मेरी सास को डायबिटिक इमरजेंसी में एम्बुलेंस आने तक चरण-दर-चरण गाइड किया। अत्यधिक सिफारिश।",
  testi_4_name: "पूजा अय्यर", testi_4_city: "बेंगलुरु",
  testi_4_quote: "लैपटॉप बैग Uber में छूट गया था। ड्राइवर ने टैग स्कैन किया, 4 मिनट में कॉल आ गया। ₹399 एक ही राइड में वसूल हो गए।",

  // CERTS
  cert_kicker: "प्रमाणित व विश्वसनीय",
  cert_title: "एंटरप्राइज़-ग्रेड अनुपालन शुरू से ही।",
  cert_audit: "त्रैमासिक ऑडिट",

  // PRICING
  pricing_kicker: "प्राइसिंग",
  pricing_title: "सुरक्षा विलासिता नहीं होनी चाहिए।",
  pricing_sub: "मुफ़्त शुरू करें। परिवार बढ़ने पर अपग्रेड करें।",
  tier_free: "Guardian Free",
  tier_free_tag: "हमेशा के लिए",
  tier_free_cta: "मुफ़्त शुरू करें",
  tier_free_1: "3 QR प्रोफ़ाइल तक",
  tier_free_2: "आपातकालीन SOS",
  tier_free_3: "सामुदायिक अलर्ट",
  tier_free_4: "Guardian AI (10/दिन)",
  tier_plus: "Guardian Plus",
  tier_plus_tag: "/माह",
  tier_plus_cta: "Plus लें",
  tier_plus_popular: "सबसे लोकप्रिय",
  tier_plus_1: "असीमित QR प्रोफ़ाइल",
  tier_plus_2: "फैमिली रडार (5 सदस्य)",
  tier_plus_3: "असीमित Guardian AI",
  tier_plus_4: "स्कैन एनालिटिक्स",
  tier_plus_5: "प्राथमिकता रिस्पॉन्डर",
  tier_corp: "Guardian Corporate",
  tier_corp_price: "कस्टम",
  tier_corp_tag: "एंटरप्राइज़",
  tier_corp_cta: "सेल्स से बात करें",
  tier_corp_1: "फ्लीट + कर्मचारी QR",
  tier_corp_2: "एडमिन डैशबोर्ड",
  tier_corp_3: "SSO + ऑडिट लॉग",
  tier_corp_4: "समर्पित सहायता",

  // FAQ
  faq_kicker: "अक्सर पूछे जाने वाले",
  faq_title: "आपके हर सवाल का जवाब।",
  faq_1_q: "Guardian QR क्या है?",
  faq_1_a: "यह एक व्यक्तिगत, निजी QR स्टिकर है। कोई भी फ़ोन कैमरे से स्कैन करते ही आपकी चुनी हुई आपातकालीन प्रोफ़ाइल देखता है और तुरंत आपसे या आपके परिवार से संपर्क कर सकता है — किसी ऐप की ज़रूरत नहीं।",
  faq_2_q: "SOS बटन 112 पर कॉल करने से कैसे अलग है?",
  faq_2_a: "SOS आपकी लाइव GPS + श्रेणी को रेडियस के हर रजिस्टर्ड रिस्पॉन्डर और आपके परिवार को समानांतर में भेजता है। यदि 60 सेकंड में कोई नहीं आता तो हम Google Maps लिंक सहित SMS भेजते हैं (इंटरनेट के बिना भी)।",
  faq_3_q: "मेरा डेटा सुरक्षित है? स्कैनर वास्तव में क्या देखता है?",
  faq_3_a: "हर फ़ील्ड — नाम, चिकित्सा नोट्स, संपर्क — आप ही तय करते हैं। और कुछ भी उजागर नहीं होता। हर स्कैन का समय-चिह्न लॉग होता है। हम GDPR-अनुरूप हैं और डेटा कभी नहीं बेचते।",
  faq_4_q: "क्या Guardian360 भारत के बाहर काम करता है?",
  faq_4_a: "हाँ। वेब ऐप + PWA + नेटिव ऐप विश्व भर में काम करते हैं। आपातकालीन नंबर (112/911/108) डिवाइस के अनुसार दिखते हैं। SMS फ़ॉलबैक किसी भी E.164 नंबर पर काम करता है।",
  faq_5_q: "आप पैसे कैसे कमाते हैं?",
  faq_5_a: "मुख्य सुरक्षा सुविधाएँ हमेशा मुफ़्त हैं। Guardian Plus (₹399/माह) असीमित प्रोफ़ाइल, फैमिली रडार और AI अनलॉक करता है। कॉर्पोरेट प्लान प्रति-सीट हैं।",

  // CTA
  bigcta_kicker: "30 सेकंड में शुरू करें",
  bigcta_title: "आपके अपनों को Guardian360 चाहिए।",
  bigcta_sub: "12,000+ परिवार पहले से ही Guardian360 से सुरक्षित हैं।",
  bigcta_btn: "अपना Guardian बनाएँ",
  bigcta_sales: "सेल्स से बात करें",

  // FOOTER
  footer_desc: "दुनिया का सबसे स्मार्ट QR-आधारित सुरक्षा नेटवर्क। इंसानों के लिए, इंसानों द्वारा बना।",
  footer_h_product: "प्रोडक्ट",
  footer_h_portals: "पोर्टल्स",
  footer_h_company: "कंपनी",
  footer_h_legal: "क़ानूनी",
  footer_l_features: "फीचर्स",
  footer_l_how: "कैसे काम करता है",
  footer_l_pricing: "प्राइसिंग",
  footer_l_mobile: "मोबाइल ऐप",
  footer_l_volunteer: "वॉलंटियर",
  footer_l_police: "पुलिस",
  footer_l_hospital: "अस्पताल",
  footer_l_corporate: "कॉर्पोरेट",
  footer_l_about: "हमारे बारे में",
  footer_l_blog: "ब्लॉग",
  footer_l_careers: "करियर",
  footer_l_contact: "संपर्क",
  footer_l_privacy: "गोपनीयता",
  footer_l_terms: "शर्तें",
  footer_l_security: "सुरक्षा",
  footer_l_gdpr: "GDPR",
  footer_rights: "सर्वाधिकार सुरक्षित।",

  // AUTH
  login_title: "वापसी पर स्वागत है।",
  login_sub: "अपने Guardian360 अकाउंट में साइन इन करें।",
  login_email: "ईमेल",
  login_password: "पासवर्ड",
  login_submit: "साइन इन",
  login_switch: "Guardian360 पर नए हैं?",
  login_switch_link: "अकाउंट बनाएँ",
  register_title: "अपना Guardian बनाएँ।",
  register_sub: "सिर्फ 30 सेकंड। कोई क्रेडिट कार्ड नहीं।",
  register_name: "पूरा नाम",
  register_phone: "फ़ोन (वैकल्पिक)",
  register_submit: "Guardian अकाउंट बनाएँ",
  register_switch: "पहले से अकाउंट है?",
  register_switch_link: "साइन इन करें",

  // SIDEBAR
  side_overview: "अवलोकन",
  side_qr: "मेरे QR कोड",
  side_sos: "आपातकालीन SOS",
  side_family: "परिवार",
  side_vehicle: "वाहन",
  side_lostfound: "खोया-पाया",
  side_community: "समुदाय",
  side_ai: "Guardian AI",
  side_admin: "एडमिन कंसोल",
  side_responder: "रिस्पॉन्डर पोर्टल",
  side_signout: "साइन आउट",
  side_light: "लाइट",
  side_dark: "डार्क",
};
export default hi;
